export interface TOCItem {
  depth: number;
  value: string;
}

export enum CodeBlockType {
  Simple = 'simple',
  Interactive = 'interactive',
  Multi = 'multi',
}

export enum TableDirection {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
  Auto = 'auto',
}
